import React, { useState, useRef, useEffect, useContext } from 'react';
import { Formik, Form, Field, FieldArray } from 'formik';
import DatePicker from 'react-datepicker';
import { getImages } from '../Const';
import { ReactSortable } from "react-sortablejs";
import { LeadsContext } from '../Context/LeadsContext';


const AnnouncementsForm = () => {
    
    const {getAnnouncements,announcementsModify} = useContext(LeadsContext);
    console.log("getAnnouncements", getAnnouncements)
    const [announcements,setAnnouncements] = useState([]);

    const [editableIndex, setEditableIndex] = useState(null);

    const handleInputChange = (input_id, field, value) => {

        setAnnouncements(prevItems =>
            prevItems.map(item =>
                item.id === input_id ? { ...item, [field]: value } : item
            )
        );
    };    

    const addAnnouncement = async (announcement,expiration,priority) => {
        const data = await announcementsModify({'action':'add_announcement','announcement':announcement,'expiration':expiration,'priority':priority});

        if(data) setAnnouncements(data);
    }

    const removeAnnouncement = (input_id) => {
        announcementsModify({'action':'remove_announcement','id':input_id});

        setAnnouncements(prevItems =>
            prevItems.filter(item => item.id != input_id)
        );
    }

    const updateAnnouncement = (id,announcement,expiration,priority) => {
        announcementsModify({'action':'update_announcement','id':id,'announcement':announcement,'expiration':expiration,'priority':priority});
    }
    
    const fetchAnnouncements = async () => {
        const data = await getAnnouncements();
    
        setAnnouncements(data);
    }
      
    useEffect(() => {
        fetchAnnouncements();
    },[]);

    return (
        <>
            <div className='d-md-flex align-items-center justify-content-between mb-4'>
                <div className='md-title text-uppercase font-26 text-lgray'>
                    Edit Announcements
                </div>
                <div>
                    <button type='button' className='blue-transparent-btn dark-transparent-btn text-uppercase'
                        onClick={() => {
                            addAnnouncement('',(new Date()).toISOString(),announcements.length);
                        }}
                    >
                        Add Announcement
                    </button>
                </div>
            </div>

                <ReactSortable
                    list={announcements}
                    setList={(currentList, sortable, store) => {
                        console.log(sortable, store, currentList);
                        if (store.dragging && store.dragging.props && JSON.stringify(store.dragging.props.list) !== JSON.stringify(currentList)) {
                            currentList.map((announcement,i) => {
                                updateAnnouncement(announcement.id,announcement.announcement,announcement.expiration,i);
                            });
                        }                       

                        setAnnouncements(currentList);
                    }}
                    handle=".ea-transparent-btn" // Optional: to restrict drag handle
                    animation={200}
                    easing="ease-out"
                >
                    {announcements.map((announcement, index) => {
                        const isEditable = editableIndex === index;
                        return (
                            <div key={index} className='ea-box mb-4'>
                                <div className='d-md-flex align-items-center justify-content-between mb-2'>
                                    <div className='sm-title text-uppercase font-1-1em fw-500'>
                                        Announcement {index + 1}
                                    </div>
                                    <div className='d-flex align-items-center'>
                                        <div className="btn-group calender-dropdown custom-dropdown announcement-dropdown me-3 position-relative">
                                            <button className="btn btn-secondary dropdown-toggle text-green mt-1" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                <img src={getImages('options-icons.png')} alt="options" />
                                            </button>
                                            <ul className="dropdown-menu dropdown-menu-custom dropdown-menu-end right-0">
                                                <button
                                                    type='button'
                                                    className='dropdown-item text-dblue font-bold text-uppercase'
                                                    onClick={() => setEditableIndex(index)}
                                                >
                                                    Edit
                                                </button>
                                                <button
                                                    type='button'
                                                    className='dropdown-item text-red font-bold text-uppercase'
                                                    onClick={() => removeAnnouncement(announcement.id)}
                                                >
                                                    Delete
                                                </button>
                                            </ul>
                                        </div>
                                        <div>
                                            <button type='button' className='ea-transparent-btn'>
                                                <img src={getImages('reorder-material.png')} alt="reorder" />
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div className='ea-custom-form'>
                                    <div className='row align-items-end'>
                                        <div className='col-md-10'>
                                            <div className='d-flex align-items-center justify-content-between'>
                                                <label>Message</label>
                                                <label>Char {announcement.announcement.length} /50</label>
                                            </div>
                                            <input
                                                name={`announcement`}
                                                value={announcement.announcement}
                                                className='form-control'
                                                maxLength="50"
                                                onChange={(e) => {handleInputChange(announcement.id, 'announcement', e.target.value)}}
                                                onBlur={(e) => {updateAnnouncement(announcement.id,e.target.value,announcement.expiration,index)}}
                                                //onChange={(e) => {
                                                //    setFieldValue(`announcements[${index}].announcement`, e.target.value);
                                                //}}
                                            />
                                        </div>
                                        <div className='col-md-2'>
                                            <label>Exp Date</label>
                                            <DatePicker
                                                selected={announcement.expiration}
                                                onChange={(date) => {
                                                    console.log(date,date.toISOString());
                                                    handleInputChange(announcement.id, 'expiration', date);
                                                    updateAnnouncement(announcement.id,announcement.announcement,date.toISOString(),index)
                                                }}
                                                //onChange={(date) => {
                                                //    setFieldValue(`announcements[${index}].expiration`, date);
                                                //}}
                                                className="form-control icon-calendar-field pe-5"
                                                dateFormat="MM/dd/yy"
                                                placeholderText="Select date"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </ReactSortable>
            {/* <button type='submit' className='theme-btn'>Save</button> */}
        </>
    );
};

export default AnnouncementsForm;
